import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeOuiNonGrpAcheteur } from '../models/TypeOuiNonGrpAcheteur';
import { Step2 } from '../../../../shared/models/component-messages/blocCommun/simp/step2';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { Oui } from '../models/Oui';

@Component({
  selector: 'app-type-oui-non-grp-acheteur',
  templateUrl: './type-oui-non-grp-acheteur.component.html'
})
export class TypeOuiNonGrpAcheteurComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeOuiNonGrpAcheteur';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;

  @Input() grpCommandes: TypeOuiNonGrpAcheteur;
  radioButtonValue;

  public step2 = new Step2();

  constructor() { }

  public ngOnInit() {
    if ((this.grpCommandes.non === RadioCheckBoxEnum.emptyValue || this.grpCommandes.non === 'Non') && this.grpCommandes.oui == null) {
      this.radioButtonValue = RadioCheckBoxEnum.nonValue;
    }
    else if (this.grpCommandes.oui) {
      this.radioButtonValue = RadioCheckBoxEnum.ouiValue;
    }
    else {
      this.radioButtonValue = RadioCheckBoxEnum.emptyValue;
    }
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getIsOui() {
    if (this.parentForm.controls[this.getUid() + '_SepAtt_non'].value === 'Oui') {
      if (!this.grpCommandes.oui) {
        this.grpCommandes.oui = new Oui();
      }
      return true;
    };
    
    this.grpCommandes.oui = null;
    return false;
    
	}

}

